import { useMemo, useState } from "react";
import { useStore } from "../data/store";
import { Btn, Check, Empty, Sheet } from "../ui/bits";
import { toFa, WEEKDAYS_SHORT } from "@soheil/core";
import { lastNDays, weekDays } from "@soheil/core";
import { useAtLimit, useEntitlement } from "../data/entitlement";
import { useToast } from "../ui/Toast";

export function Habits() {
  const { state, dispatch, today } = useStore();
  const [adding, setAdding] = useState(false);
  const [title, setTitle] = useState("");
  const [neverZero, setNeverZero] = useState("");

  const habits = useMemo(
    () => state.habits.filter((h) => !h.archived && !h.deletedAt).sort((a, b) => a.sortOrder - b.sortOrder),
    [state.habits],
  );
  const ent = useEntitlement();
  const atLimit = useAtLimit("habits", habits.length);
  const toast = useToast();

  const week = weekDays(today);
  const isDone = (id: string, day: string) => state.habitLogs.some((l) => l.habitId === id && l.localDate === day);

  return (
    <div className="screen">
      <header className="daybar">
        <div><h1>عادت‌ها</h1><span>هر روز یک قدم، حتی کوچک</span></div>
        <button
          className="link"
          onClick={() => {
            if (atLimit) {
              // پیام باید بگوید چرا و چه کار می‌شود کرد، نه فقط «نمی‌شود»
              toast(`نسخهٔ رایگان تا ${toFa(ent.limits.habits)} عادت است — در تب «من» ارتقا بده`);
              return;
            }
            setAdding(true);
          }}
        >
          {atLimit ? "افزودن 🔒" : "افزودن"}
        </button>
      </header>

      {habits.length === 0 ? (
        <Empty icon="🌱" title="هنوز عادتی نساخته‌ای" hint="با یکی شروع کن، نه ده تا." />
      ) : (
        <ul className="habits">
          {habits.map((h) => {
            const done = isDone(h.id, today);
            const streak = countStreak(h.id);
            return (
              <li key={h.id} className="habit">
                <button
                  className="habit-main"
                  onClick={() => dispatch({ type: "toggleHabit", habitId: h.id, day: today })}
                >
                  <Check done={done} />
                  <div className="habit-txt">
                    <b>{h.icon} {h.title}</b>
                    <span>{h.domain}{streak > 0 ? ` · 🔥 ${toFa(streak)} روز` : ""}</span>
                  </div>
                </button>

                <div className="habit-week">
                  {week.map((d, i) => (
                    <span key={d} className="wd" data-on={isDone(h.id, d) ? "1" : "0"} data-today={d === today ? "1" : "0"}>
                      {WEEKDAYS_SHORT[i]}
                    </span>
                  ))}
                </div>

                {!done && h.neverZero && (
                  <button
                    className="neverzero"
                    onClick={() => dispatch({ type: "toggleHabit", habitId: h.id, day: today, neverZero: true })}
                  >
                    امروز سخت است؟ فقط «{h.neverZero}»
                  </button>
                )}
              </li>
            );
          })}
        </ul>
      )}

      <Sheet open={adding} onClose={() => setAdding(false)} title="عادت جدید">
        <form
          onSubmit={(e) => {
            e.preventDefault();
            const t = title.trim();
            if (!t) return;
            dispatch({
              type: "addHabit",
              habit: {
                title: t, neverZero: neverZero.trim() || "فقط شروعش کن",
                domain: "عمومی", icon: "🌱",
                scheduleType: "daily", scheduleConfig: {}, archived: false,
              },
            });
            setTitle(""); setNeverZero(""); setAdding(false);
          }}
        >
          <label className="lbl">عادت</label>
          <input className="input" autoFocus value={title} onChange={(e) => setTitle(e.target.value)} placeholder="مثلاً: ۳۰ دقیقه مطالعه" />
          <label className="lbl">نسخهٔ «هرگز صفر»</label>
          <input className="input" value={neverZero} onChange={(e) => setNeverZero(e.target.value)} placeholder="مثلاً: یک صفحه بخوان" />
          <p className="hint">
            روزهایی که نمی‌شود کامل انجامش داد، نسخهٔ کوچک زنجیره را زنده نگه می‌دارد.
          </p>
          <Btn type="submit" full>ساختن</Btn>
        </form>
      </Sheet>
    </div>
  );

  function countStreak(habitId: string): number {
    const days = lastNDays(today, 120);
    let n = 0;
    for (let i = days.length - 1; i >= 0; i--) {
      if (state.habitLogs.some((l) => l.habitId === habitId && l.localDate === days[i])) n++;
      else if (days[i] !== today) break;
    }
    return n;
  }
}
